module.exports = __webpack_public_path__ + "static/media/7337c544-5dae-40ca-b241-14a0f91d3ccc.76351c61.JPG";